
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.25 29.14l2.25-7.968a12.11 12.11 0 01-.906-2.766 15.024 15.024 0 01-.281-2.922c0-1.75.328-3.385.984-4.906a12.735 12.735 0 012.703-4 12.735 12.735 0 014-2.703c1.52-.656 3.156-.984 4.906-.984 1.75 0 3.386.328 4.906.984a12.735 12.735 0 014 2.703 12.735 12.735 0 012.704 4c.656 1.52.984 3.156.984 4.906 0 1.75-.328 3.386-.984 4.906a12.733 12.733 0 01-2.703 4 12.735 12.735 0 01-4 2.704c-1.521.656-3.157.984-4.907.984-1 0-1.974-.094-2.922-.281-.947-.188-1.87-.49-2.765-.907L1.25 29.14zm2.844-2.843l4.312-1.188c.104-.041.203-.073.297-.094.094-.02.193-.03.297-.03.23 0 .443.02.64.062.199.041.402.104.61.187.75.292 1.516.526 2.297.703a10.64 10.64 0 002.36.266c2.978 0 5.51-1.042 7.593-3.125s3.125-4.614 3.125-7.594c0-2.979-1.042-5.51-3.125-7.593-2.083-2.084-4.615-3.125-7.594-3.125S9.396 5.807 7.312 7.89c-2.083 2.083-3.125 4.614-3.125 7.593 0 .813.058 1.615.172 2.406.115.792.38 1.542.797 2.25.146.292.224.6.235.922.01.323-.026.63-.11.922l-1.187 4.313z","fill":"#003C4A"}}),_c('path',{attrs:{"d":"M8.438 14.453h2.5v2.5h-2.5v-2.5zm5 0h2.5v2.5h-2.5v-2.5zm5 0h2.5v2.5h-2.5v-2.5z","fill":"#003C4A"}})])
          )
        }
      }
    